import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const TOAST_BOTTOM_PX = 48
const TOAST_GAP_PX = 8
const TOAST_PADDING = '12px 24px 12px 16px'
const TOAST_SHADOW = '0 6px 8px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.08)'
const TOAST_Z_INDEX = 9999
const TOAST_ENTER_OFFSET_PX = 20
const TOAST_ANIMATION_DURATION = '0.3s'

const BADGE_SIZE_PX = 28
const BADGE_RADIUS_PX = 22.4

const TEXT_COLOR = '#3f4145'

const MESSAGE_FONT_SIZE_PX = 15
const MESSAGE_LINE_HEIGHT_PX = 22
const MESSAGE_LETTER_SPACING_PX = -0.075

const TIMESTAMP_FONT_SIZE_PX = 13
const TIMESTAMP_LINE_HEIGHT_PX = 18

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, ${TOAST_ENTER_OFFSET_PX}px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`

const slideDown = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  to {
    opacity: 0;
    transform: translate(-50%, ${TOAST_ENTER_OFFSET_PX}px);
  }
`

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isExiting',
})<{ isExiting: boolean }>`
  position: fixed;
  bottom: ${TOAST_BOTTOM_PX}px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: ${TOAST_GAP_PX}px;
  padding: ${TOAST_PADDING};
  background-color: ${({ theme }) => theme.color.white};
  border-radius: 9999px;
  box-shadow: ${TOAST_SHADOW};
  white-space: nowrap;
  pointer-events: none;
  z-index: ${TOAST_Z_INDEX};
  animation: ${({ isExiting }) => (isExiting ? slideDown : slideUp)} ${TOAST_ANIMATION_DURATION} ease forwards;
`

export const IconBadge = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor: string }>`
  width: ${BADGE_SIZE_PX}px;
  height: ${BADGE_SIZE_PX}px;
  border-radius: ${BADGE_RADIUS_PX}px;
  background-color: ${({ bgColor }) => bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.white};
`

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const MessageLine = styled.p`
  font-size: ${MESSAGE_FONT_SIZE_PX}px;
  font-weight: 500;
  line-height: ${MESSAGE_LINE_HEIGHT_PX}px;
  letter-spacing: ${MESSAGE_LETTER_SPACING_PX}px;
  color: ${TEXT_COLOR};
`

export const TimestampLine = styled.p`
  font-size: ${TIMESTAMP_FONT_SIZE_PX}px;
  font-weight: 400;
  line-height: ${TIMESTAMP_LINE_HEIGHT_PX}px;
  color: ${TEXT_COLOR};
`
